<template>
  <textarea
    v-model="internalValue"
    class="base-textarea"
    :class="{ 'base-textarea--invalid': invalid }"
  />
</template>

<script>
  export default {
    name: 'BaseTextarea',
    emits: ['update:modelValue'],
    props: {
      modelValue: {
        type: String,
        required: true,
      },
      invalid: Boolean,
    },
    computed: {
      internalValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-textarea {
    &--invalid {
      border-color: var(--itr-color-danger) !important;
    }
  }
</style>
